/**
 * @generated SignedSource<<fc14ff40bbb34bcc4117f54458d83ddd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleImageGalleryContent$data = {
  readonly entityId: string;
  readonly headline: string | null;
  readonly shortUrl: string | null;
  readonly socialHeadline: string | null;
  readonly urlAlias: string;
  readonly " $fragmentType": "articleImageGalleryContent";
};
export type articleImageGalleryContent$key = {
  readonly " $data"?: articleImageGalleryContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleImageGalleryContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleImageGalleryContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "socialHeadline",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "2804416c79a8f50a58612579d2a2e61b";

export default node;
